import { Enum } from '~/lib/enum';

const WayFinder = new Enum({
  OVERVIEW: 'overview',
  STEP_AND_MORE: 'step-and-more',
});

export default {};
export { WayFinder };
